import { connect } from "knockout-store";
import { getTitle } from "../../utils/routing";

function pageViewModel(params) {
  const vm = {};
  vm.html = params.html;
  vm.title = () => {
    return getTitle(params.route());
  };
  return vm;
}

function mapStateToParams({ html, route }) {
  return { html, route };
}

export default connect(mapStateToParams)(pageViewModel);
